let tpl = require('./location.tpl.html');

class LocationController {
    constructor($locationService) {
        this.$locationService = $locationService;

        //map controller variable with service variable
        this.result = this.$locationService.result;
        //update location info async
        this.$locationService.update();
    }
}

LocationController.$inject = ['LocationService'];

let Location = {
    bindings: {},
    templateUrl: tpl,
    controller: LocationController
};

export default Location;


// WEBPACK FOOTER //
// ./src/equalone-ui/components/location/location.component.js